import { useCallback, useEffect, useState } from "react";
import { CampaignServiceError, getCampaignDashboard } from "../api";
import type { CampaignDashboardResponse } from "../types";
import type { CampaignPageFilter } from "../types/campaign.ui";

export function useCampaignDashboard(filters: CampaignPageFilter) {
  const [data, setData] = useState<CampaignDashboardResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const reload = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      setData(await getCampaignDashboard(filters));
    } catch (loadError) {
      setData(null);
      setError(
        loadError instanceof CampaignServiceError
          ? loadError.message
          : "Failed to load campaign dashboard.",
      );
    } finally {
      setIsLoading(false);
    }
  }, [filters]);
  useEffect(() => {
    void reload();
  }, [reload]);
  return { data, isLoading, error, reload };
}
